import type {AwsRumConfig} from 'aws-rum-web'

const hasAllRequiredEnvVariables = () => {
  const CLOUDWATCH_ENV_VARIABLES = [
    process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_ENABLE,
    process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_GUEST_ROLE_ARN,
    process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_IDENTITY_POOL_ID,
    process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_ENDPOINT,
    process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APPLICATION_ID,
  ]

  return CLOUDWATCH_ENV_VARIABLES.every(Boolean)
}

const inBrowserEnvironment = () => typeof window !== 'undefined'

let awsRum

export async function initializeCloudwatch(): Promise<void> {
  if (!inBrowserEnvironment() || awsRum || !hasAllRequiredEnvVariables()) {
    return
  }

  const {AwsRum} = await import('aws-rum-web')

  const telemetries = process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_TELEMETRIES
    ? process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_TELEMETRIES.split(',')
    : ['performance', 'errors', 'http']

  const allowCookies =
    typeof process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_TELEMETRIES !== 'undefined'
      ? Boolean(Number(process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_TELEMETRIES))
      : true

  const enableXRay =
    typeof process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_ENABLE_XRAY !== 'undefined'
      ? Boolean(Number(process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_ENABLE_XRAY))
      : false

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: Number(process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_SESSION_SAMPLE_RATE) || 1,
      guestRoleArn: process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_GUEST_ROLE_ARN,
      identityPoolId: process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_IDENTITY_POOL_ID,
      endpoint: process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_ENDPOINT,
      telemetries,
      allowCookies,
      enableXRay,
    }

    const APPLICATION_ID: string = process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APPLICATION_ID
    const APPLICATION_VERSION: string =
      process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APPLICATION_VERSION || '1.0.0'
    const APPLICATION_REGION: string =
      process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APPLICATION_REGION || 'us-east-1'

    awsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config)
  } catch (error) {
    console.error(error)
  }
}
